module.exports = __webpack_public_path__ + "media/brands/cadillac-94df7fad.png";